import Modal from "./modals/Modal.jsx";
import EventsTable from "./events/EventsTable.jsx";

const DateBox = ({ dayObj, today, events = [] }) => {
    const { date, inCurrentMonth } = dayObj;
    const isToday = date.isSame(today, "day");
    const hasEvent = events.length > 0;

    return (
        <div className="party-calendar-cell">
            <Modal>
                <Modal.Open opens="events-list">
                    <button type="button"
                        aria-label={`${date.format("DD MMMM YYYY")}: ${events.length} events`}
                        aria-current={isToday ? "date" : undefined}
                        className={`party-calendar-day ${hasEvent ? "has-events" : ""} ${isToday ? "is-today" : ""} ${!inCurrentMonth ? "outside-month" : ""}`}>
                        <span>{date.format("D")}</span>
                        {hasEvent && <span className="party-calendar-dots" aria-hidden="true">
                            {Array.from({ length: Math.min(events.length, 3) }, (_, i) => <i key={i} />)}
                        </span>}
                    </button>
                </Modal.Open>
                <Modal.Window name="events-list" label={`Events on ${date.format("DD MMMM YYYY")}`}>
                    <EventsTable events={events}/>
                </Modal.Window>
            </Modal>
        </div>
    );
};

export default DateBox;
